module.exports = __webpack_public_path__ + "static/media/beagleboard-embedded.e2d6e62b.svg";